import React, { Component, Fragment } from 'react';
import { bool } from 'prop-types';
import IntlInput from '../common/IntlInput';
import ContractsInput from './ContractsInput';
import { FMessage } from '../../hoc/IntlComponents';
import CustomControl from '../CustomControl/CustomControl';

class ContractsIPForm extends Component {
  static propTypes = {
    loading: bool,
  };

  state = {
    match: false,
  };

  handleChangeMatch = () => {
    const { match } = this.state;
    const { getCommonProps } = this.props;
    this.setState((prevState) => ({ match: !prevState.match }));
    const inputHandler = getCommonProps('actual_address', 0).onChange;
    const addresToCopyProps = getCommonProps('address', 0);
    const data = { name: 'actual_address', value: '' };
    if (!match) {
      data.value = addresToCopyProps.value;
    }
    inputHandler({ target: data });
  };

  getActAddressProperty = (prop) => {
    const { match } = this.state;
    const { getCommonProps } = this.props;
    const addresToCopyProps = getCommonProps('address', 0);
    const propsToReplace = getCommonProps('actual_address', 0);
    return match ? addresToCopyProps[prop] : propsToReplace[prop];
  };

  getActAddressCommonProps = () => {
    const { disabled: globalDisabled, getCommonProps } = this.props;
    const { match } = this.state;
    const { disabled, ...restProps } = getCommonProps('actual_address', 0);
    return {
      ...restProps,
      disabled: match || globalDisabled,
    };
  };

  render() {
    const { getCommonProps, customCheckBoxId, disabled } = this.props;
    const { match } = this.state;

    return (
      <Fragment>
        <ContractsInput colProps={{ md: 12 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('name', 0)} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 6 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('ogrnip')} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 6 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('inn')} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 12 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('address', 0)} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 12 }}>
          <IntlInput
            className="form-group-upper-label"
            {...this.getActAddressCommonProps()}
            value={this.getActAddressProperty('value')}
            error={this.getActAddressProperty('error')}
            noErrorText
          >
            <div className="contracts-match-checkbox-wrapper">
              <CustomControl
                id={customCheckBoxId}
                className="custom-control-xs isMatch"
                name={customCheckBoxId}
                value={customCheckBoxId}
                onChange={this.handleChangeMatch}
                checked={match}
                disabled={disabled}
              >
                <FMessage id="contracts.match.type-1" />
              </CustomControl>
            </div>
          </IntlInput>
        </ContractsInput>

        <ContractsInput className="form-group-upper-label" colProps={{ md: 6 }}>
          <IntlInput {...getCommonProps('email')} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 6 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('phone')} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 12 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('bank_name')} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 12 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('bank_account')} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 3 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('bik')} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 9 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('corr_account')} />
        </ContractsInput>

        <ContractsInput colProps={{ md: 12 }}>
          <IntlInput className="form-group-upper-label" {...getCommonProps('edo_id')} />
        </ContractsInput>
      </Fragment>
    );
  }
}

export default ContractsIPForm;
